export default __webpack_public_path__ + "static/media/cp_geo_ga.b5b9b62f.svg";